<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Вход</h1>
      <p v-if="error" class="auth-error">{{ error }}</p>
      <q-input outlined v-model="email" type="email" label="Email" autocomplete="username" @keyup.enter="submit" />
      <q-input outlined v-model="password" type="password" label="Пароль" autocomplete="current-password" @keyup.enter="submit" />
      <q-btn color="primary" label="Войти" :loading="loading" @click="submit" />
      <div class="auth-links">
        <router-link to="/forgot-password">Забыли пароль?</router-link>
        <router-link to="/register">Регистрация</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth";

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      loading: false,
      auth: new AuthService(),
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.loading = true;
      try {
        await this.auth.login(this.email, this.password);
        const redirect = this.$route.query.redirect || '/';
        await this.$router.push(redirect);
      } catch (err) {
        this.error = err.message || 'Не удалось войти';
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  padding: 24px;
}
.auth-card {
  width: min(420px, 100%);
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px;
  background: #fff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(20, 32, 51, 0.06);
  text-align: left;
  h1 {
    margin: 0 0 8px;
    color: #202938;
  }
}
.auth-error {
  margin: 0;
  color: #c10015;
}
.auth-links {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  a {
    color: #1976d2;
  }
}
</style>
